import { GUEST_SCOPE } from '../auth/planLimits'
import { loadLookupsAndMarks, loadStatements } from '../contextsV2/store'
import { readManualContexts } from '../intelligence/contextLab/manualContexts'
import { buildContextsExport, type ContextsExport } from './contextsExport'

/** Reads what the person made in Contexts, on this device, for their export. Someone without an account is the guest scope. */
export async function readContextsExport(
  notes: readonly { id: string; manualTitle: string | null; derivedTitle: string }[],
  ownerId: string | null | undefined,
): Promise<ContextsExport> {
  const owner = ownerId || GUEST_SCOPE
  const [contexts, statements, { marks }] = await Promise.all([readManualContexts(owner), loadStatements(owner), loadLookupsAndMarks()])
  return buildContextsExport({ contexts, statements, marks, noteTitles: new Map(notes.map(note => [note.id, note.manualTitle ?? note.derivedTitle])) })
}

/** What the quick local recovery copy carries of Contexts: the raw records and acts, read for the account or the guest scope. */
export async function readRecoverableContexts(ownerId: string | null | undefined) {
  const owner = ownerId || GUEST_SCOPE
  const [contexts, contextStatements] = await Promise.all([readManualContexts(owner).catch(() => []), loadStatements(owner).catch(() => [])])
  return { contexts, contextStatements }
}
